<template>
    <section class="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        <section>
            <div v-if="model.avatar" class="flex items-center w-max bg-sepBorder bg-opacity-40 dark:bg-dark.tableBG p-3 px-5 rounded">
                <div class="rounded-full h-24 w-24" :style="{ backgroundImage: `url(${model.avatar})`, backgroundSize: 'cover', backgroundPosition: 'center' }"></div>
                <div class="ml-5">
                    <h2 class="font-bold truncate w-36">{{ model.name }}</h2>
                    <span class="text-xs text-gray-600">{{ model.assignment }}</span>
                    <div class="my-1">
                        <slot v-if="model.platform==1"><span class="hidden">O</span><img src="@/assets/images/of_logo.png"  class="h-5"/></slot>
                        <slot v-else-if="model.platform==2"><span class="hidden">F</span><img src="@/assets/images/fansly_logo.png" title="Fansly" alt="Fansly" class="h-5"/></slot>
                    </div>
                    <span class="font-light">{{model.performerTop < 100 ? model.performerTop + '%':null}}</span>
                </div>
            </div>
        </section>
        <div class="lg:col-span-2 sm:ml-2">
            <div class="col-span-full text-decline text-right">
                <span v-if="!hasSession">{{ $t('scraper_modal.p1') }}</span>
            </div>
            <div class="col-span-full mt-1">
                <div class="flex items-center space-x-4">
                    <MazPicker
                        v-model="dRange"
                        size="sm"
                        pickerPosition="right"
                        :label="$t('select_period')"
                        :max-date="new Date().toISOString().split('T')[0]"
                        double
                    />
                    <MazBtn @click="fetchScrapingStatus" class="whitespace-nowrap">
                        Check Status
                    </MazBtn>
                </div>
            </div>
            <br />
            <div v-if="scrapingStatus.length > 0" class="col-span-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                <div v-for="(status, index) in scrapingStatus" :key="index" class="flex p-1.5 px-2.5 items-center justify-between border rounded-lg shadow">
                    <h3>{{ status.date }}</h3>
                    <font-awesome-icon v-if="status.loading" class="animate-spin" icon="fas fa-spinner" />
                    <font-awesome-icon v-else @click="scrapeAgain(status.date, index)" :icon="status.scraped ? 'fas fa-check' : 'fas fa-download'" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { scrape_data, get_sessions, scraping_status } from "@/api/admin_api.js";
    import MazSelect from 'maz-ui/components/MazSelect';

    export default {
        components: { MazSelect },
        props: ['model'],
        data() {
            return {
                hasSession: true,
                dRange: {start: null, end: null},
                dateOptions: this.generateDateOptions(),
                scrapingStatus: [],
                dateFrom: this.$moment().subtract(9, 'days').format('YYYY-MM-DD'),
                dateTo: this.$moment().format('YYYY-MM-DD'),
            }
        },
        watch: {
            dRange: function (n,o) {
                this.dateFrom = n.start ? n.start : this.dateFrom;
                this.dateTo = n.end ? n.end : this.dateTo;
            },
        },
        methods: {
            scrapeAgain(date, index) {
                this.scrapingStatus[index].loading = true;
                if (confirm(this.$t('scraper_modal.confirm'))) {
                    this.scrapeData(date, index);
                }
            },
            async scrapeData(date, i) {
                try {
                    let result = await scrape_data(this.$cookies.get('admin_auth_token'), this.model.id, date);
                    if (result.success) {
                        this.scrapingStatus[i].scraped = true;
                    } else {
                        this.scrapingStatus[i].scraped = false;
                        if (result.message) {
                            alert(result.message);
                        }
                    }
                } catch (error) {
                    console.error(error);
                    alert(this.$t('scraper_modal.error_scraping'));
                } finally {
                    this.scrapingStatus[i].loading = false;
                }
            },
            async fetchScrapingStatus() {
                try {
                    this.scrapingStatus = await scraping_status(this.$cookies.get('admin_auth_token'), this.model.id, this.dateFrom, this.dateTo);
                } catch (error) {
                    console.error(error);
                    alert(this.$t('scraper_modal.error_fetching_status'));
                }
            },
            generateDateOptions() {
                const options = [];
                for (let i = 0; i < 30; i++) {
                    const date = this.$moment().subtract(i, 'days').format('YYYY-MM-DD');
                    options.push({ value: date, text: date });
                }
                return options;
            }
        },
        async mounted() {
            this.loading = true;
            let session = await get_sessions(this.$cookies.get('admin_auth_token'), this.model.id);
            if (session && session.sessionCount > 0) {
                this.hasSession = true;
            }
            setTimeout(() => {
                this.loading = false;
            }, 500);
        }
    }
</script>